module.exports = __webpack_public_path__ + "static/media/BP.fe06b2b7.png";